"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const Box_1 = require("./Box");
exports.Paragraph = Box_1.Box.withComponent('p');

//# sourceMappingURL=Paragraph.js.map
